import { Box, Button, Typography } from "@mui/material";

export default function ContactedStatusControl({
  contacted = false,
  disabled = false,
  loading = false,
  error = "",
  onToggle,
  sx,
}) {
  return (
    <Box
      sx={{
        mb: 2,
        display: "grid",
        gap: 1,
        justifyItems: "start",
        ...sx,
      }}
    >
      <Typography sx={{ fontWeight: 700 }}>Contacted Status:</Typography>
      <Button
        variant={contacted ? "outlined" : "contained"}
        color={contacted ? "success" : "primary"}
        disabled={disabled || loading}
        onClick={onToggle}
        sx={{ textTransform: "none", fontWeight: 700 }}
      >
        {loading ? "Saving..." : contacted ? "Mark as not contacted" : "Mark as contacted"}
      </Button>
      {error ? (
        <Typography sx={{ fontSize: "0.86rem", color: "#b91c1c" }}>{error}</Typography>
      ) : null}
    </Box>
  );
}
